// JsFromRoutes CacheKey 1a604754911e3ce4dc1aaf667162ddd3
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  get: definePathHelper('get', '/documents/export'),
  create: definePathHelper('post', '/documents/export'),
}
